import axios from 'axios'
import { apiConfigCommon } from '@/api/config'

export let apiLogin = function (username, password) {
  return axios.post('/api/v0/auth/contract/', {
    username: username,
    password: password
  }, apiConfigCommon())
}

export let apiTokenVerify = function (token) {
  return axios.post('/api/v0/auth/verify/', {
    token: token
  }, apiConfigCommon())
}



// WEBPACK FOOTER //
// ./src/api/auth.js